/**
 * Directive: addressList
 */
angular.module('acme.common.directive.addressList', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.config',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.dataGrid.controllers',
  'acme.view.application.partners.create.removeAddressModal.controllers'
])
.directive('addressList', ['$timeout', '$uibModal', 'ApiService', 'GridStateFactory', 'GridDefinitionFactory', function($timeout, $uibModal, ApiService, GridStateFactory, GridDefinitionFactory) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/address/list/list.tpl.html',
      scope: {
        viewId: '@',
        loadPreferences: '@',
        hideCreate: '=?',
        hideRemove: '@',
        listId: '@',
        addressId: '@',
        organizationId: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', 'ConfigService', function($scope, ConfigService) {

        $scope.addressList = {

          model: [],
          removeModal: {},

          gridState: new GridStateFactory(),
          gridDefinition: new GridDefinitionFactory(),
          addressListGridName: 'addressList.grid' + $scope.organizationId + '-' + $scope.listId,
          selectedRows: {},
          pageSize: 4,

          optionsOverride: {
            data: 'addressList.model',
            paginationPageSizes: [4],
            paginationPageSize: 4,
            appScopeProvider: {
              onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
                $scope.addressList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
              },
              onDataGridSortChange: function(grid, columns, page) {
                $scope.addressList.onDataGridSortChange(grid, columns, page);
              },
              onDataGridSelectionChange: function (row, e) {
                $scope.addressList.onDataGridSelectionChange(row, e);
              },
              onEditClick: function(item) {
                $scope.addressList.edit(item);
              },
              onRemoveClick: function(item) {
                $scope.addressList.remove(item);
              }
            },
            columnDefs: [
              {
                field: 'edit',
                displayName: 'Edit',
                onCellNavClick: function(row, col) {
                  $scope.addressList.optionsOverride.appScopeProvider.onEditClick(row.entity);
                },
                cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onEditClick(row.entity)" role="link">Edit<span class="sr-only"> Address</span></a></div>',
                enableHiding: false,
                enableSorting: false,
                width: 60
              },
              {
                field: 'streetAddress1',
                displayName: 'Address 1'
              },
              {
                field: 'streetAddress2',
                displayName: 'Address 2'
              },
              {
                field: 'city',
                displayName: 'City'
              },
              {
                field: 'state',
                displayName: 'State / Province'
              },
              {
                field: 'country',
                displayName: 'Country'
              },
              {
                field: 'zipCode',
                displayName: 'Zip / Postal Code'
              },
              {
                field: 'isPrimary',
                displayName: 'Primary',
                cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-show="row.entity.isPrimary">Yes</span><span data-ng-hide="row.entity.isPrimary">No</span></div>'
              },
              {
                field: 'remove',
                displayName: 'Remove',
                enableSorting: false,
                onCellNavClick: function(row, col) {
                  $scope.addressList.optionsOverride.appScopeProvider.onRemoveClick(row.entity);
                },
                cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onRemoveClick(row.entity)" role="button">Remove<span class="sr-only">-Opens a Dialog</span></a></div>',
                enableHiding: false,
                visible: (!$scope.hideRemove),
                width: 60
              }
            ]
          },

          init: function() {
            $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

            this.gridDefinition.init(this.addressListGridName, this.optionsOverride, $scope.viewId, $scope.loadPreferences);
            $scope.$on('AddressList::Refresh', this.onAddressListRefresh);
          },

          initData: function() {
            var self = $scope.addressList, props = self.gridDefinition.getGridState();
            self.gridState.updateGridState(props.page, props.pageSize, props.sortField || 'id', props.sortDirection || 'desc');

            if ($scope.addressId) {
              self.getAddresses({ id: $scope.addressId });
            }else {
              self.getAddresses();
            }
          },

          edit: function(address) {
            // Show modal for editing
            $scope.$emit('AddressList::Edit', { address: address });
          },

          create: function() {
            $scope.$emit('AddressList::Create');
          },

          remove: function(address) {

            var self = $scope.addressList;

            self.removeModal = $uibModal.open({
              templateUrl: 'views/application/views/partners/create/modals/RemoveAddressModal.tpl.html',
              size: 'md',
              controller: 'RemoveAddressModalController',
              resolve: {
                address: function() {
                  return address;
                }
              }
            });

            self.removeModal.result.then(function(address) {
                //add the secondaryContact
                ApiService.organizations.addresses.remove($.extend({ organizationId: $scope.organizationId }, address)).then(function(response) {
                  self.success.remove(response);
                  var found = self.findAddress(address.id);

                  if (found) {
                    self.model.splice(found.index, 1);
                    $timeout(function () {
                      $scope.$broadcast('DataGrid::ResizeGrid', {
                        name: self.gridDefinition.options.gridName,
                        datasetLength: self.model.length
                      });
                    }, 0);
                  }
                }, self.error.remove);
              },
              function() {
                //do nothing
              });
          },

          getAddresses: function(selectedAddress) {
            ApiService.organizations.addresses.list($.extend({ organizationId: $scope.organizationId }, this.gridState.getGridState())).then(function(response) {
              var self = $scope.addressList;

              self.success.getAddresses(response);
              // Select address after short next tick
              if (selectedAddress) {
                $timeout(function () {
                  var found = self.findAddress(selectedAddress.id);
                  if (found) {
                    self.gridDefinition.selectRows(self.model[found.index]);
                    if (self.gridDefinition.isAccessbilityEnabled) {
                      self.gridDefinition.gridApi.selection.selectRow(self.model[found.index]);
                    }else {
                      self.gridDefinition.options.api.forEachNode(function (node) {
                        if (node.data.addressId + "" === selectedAddress.id) {
                          node.setSelected(true);
                          return true;
                        }
                      });
                    }
                  }
                }, 10);
              }
            }, this.error.getAddresses);
          },

          findAddress: function(id) {
            var i, ii,
                r = false;

            for (i=0,ii=this.model.length;i<ii;i++) {
              if ("" + this.model[i].id === "" + id) {
                r = {
                  address: this.model[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          findPrimaryAddress: function() {
            var i, ii,
                r = false;

            for (i=0,ii=this.model.length;i<ii;i++) {
              if (this.model[i].isPrimary) {
                r = {
                  address: this.model[i],
                  index: i
                };
                break;
              }
            }

            return r;
          },

          process: function(addresses) {

            var i, ii;

            for (i=0,ii=addresses.length;i<ii;i++) {
              // Copy for downstream use
              addresses[i].addressId = addresses[i].id;
            }

            return addresses;

          },

          success: {
            remove: function(response) {

            },
            getAddresses: function(response) {
              var found,
                  self = $scope.addressList;

              self.model = self.process(response.data.payload.list);
              self.gridDefinition.isLoaded = true;

              // Using an event to reduce coupling between directive and view
              found = self.findPrimaryAddress();
              if (found) {
                $scope.$emit('AddressList::PrimaryAddress', found);
              }

              $timeout(function () {
                $scope.$broadcast('DataGrid::ResizeGrid', {
                  name: self.gridDefinition.options.gridName,
                  datasetLength: self.model.length,
                  totalItems: response.data.payload.pagination.count
                });
              }, 10);
            }
          },

          error: {
            remove: function(response) {},
            getAddresses: function(response) {
              var self = $scope.addressList;
              self.gridDefinition.isLoaded = true;
            }
          },

          onDataGridSelectionChange: function(row, e) {
            var i, ii,
              self = $scope.addressList;

            if (row instanceof Array) {
              for (i=0,ii=data.length;i<ii;i++) {
                self.selectedRows[row[i].entity.id] = { selected: row[i].isSelected, data: row[i].entity };
              }
            }else {
              self.selectedRows[row.entity.id] = { selected: row.isSelected, data: row.entity };
            }
            $scope.$emit('AddressList::Select', { address: row.entity, selected: row.isSelected });
          },

          onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
            var self = $scope.addressList;
            self.gridState.updateGridState(newPage, pageSize);
            if (sortField) {
              self.gridState.updateGridState(null, null, sortField, null);
            }
            if (sortDirection) {
              self.gridState.updateGridState(null, null, null, sortDirection);
            }
            // Autoselect if address exists
            if ($scope.addressId) {
              self.getAddresses({ id: $scope.addressId });
            }else{
              self.getAddresses();
            }
          },

          onDataGridSortChange: function(grid, columns, page) {
            var self = $scope.addressList, data = columns[0];
            if(data) {
              self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
              self.getAddresses();
            }
          },

          onAddressListRefresh: function(e, data) {
            var self = $scope.addressList;
            // Autoselect if address is available
            if (data && data.address) {
              self.getAddresses(data.address);
            }else{
              self.getAddresses();
            }
          }


        };

        $scope.addressList.init();

      }]

    };

}]);